export class Method {
    // Wire TAB
    wireAccountHolder: string;
    wireBankName: string;
    wireBankCountryId: any;
    wireIban: string;
    wireSwift: string;
    // Payoneer TAB
    payoneerEmail: string;
    // PayPal TAB
    payPalEmail: string;
}

export class Payterm {
  preffered: string;
  payTerm: string;
  minAmount: number;
  currentRevenue: number;
  payoutDate: any;
  wireFee: number;
  payoneerFee: number;
  payPalFee: number;
}

export class Preferred {
  prefferedPayoutMethod: number;
}
